<template>
  <div class="modal light" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('modals.agreement.title') }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <div
          v-for="(agreement, index) in agreements"
          v-html="agreement"
          v-bind:key="index"
          class="m-b-20"
        ></div>
        <div class="box-button m-t-75">
          <div class="full-50">
            <!-- <label class="checkbox">
              <input v-model="isRemember" type="checkbox" />
              ไม่ต้องแสดงอีก
            </label> -->
          </div>
          <button class="button full-50 is-primary" @click="closeModal">
            {{ $t('modals.confirmBtn') }}
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import apiLookup from '@/api/lookup'
import { setRememberAgreement } from '@/utils/agreement'

export default {
  name: 'ModalDeposit',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      agreements: []
    }
  },
  mounted() {
    this.lookupAgreements()
  },
  methods: {
    async lookupAgreements() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const data = await apiLookup.lookupAgreements()
          this.agreements = data.agreements

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    closeModal() {
      this.$emit('closeModal', null)

      // if (this.isRemember === true) {
      setRememberAgreement()
      // }
    }
  }
}
</script>
